import { render, staticRenderFns } from "./roomResults.vue?vue&type=template&id=ef494f70&scoped=true"
import script from "./roomResults.vue?vue&type=script&lang=js"
export * from "./roomResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef494f70",
  null
  
)

export default component.exports